
import { useAuth } from '../../../../app/modules/auth'
import { Languages } from './Languages'
import { PERMISSION_CONSTANTS } from '../../../../app/core/constants/common/permission-constants';
import { t } from 'i18next'
import { Impersonation } from './Impersonation'
import PermissionWrapper from '@/core/wrappers/permission-wrapper';
import { Link } from 'react-router-dom';



function HeaderUserMenu(data: any) {
  const { currentUser, logout } = useAuth()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-semibold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            {data.profileImage !== undefined && (
              <img
                alt="Logo"
                src={
                  data.profileImage
                    ? `data:image/png;base64,${data.profileImage}`
                    : "/logo/07804c87-9a27-4b5b-9092-fadb2f043faf.png"
                }
                onError={(e) => {
                  if (data.profileImage) {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = "/logo/07804c87-9a27-4b5b-9092-fadb2f043faf.png";
                  }
                }}
              />
            )}
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bold d-flex align-items-center fs-5'>
              {currentUser?.preferred_username}
            </div>
            <span className='fw-semibold text-muted text-hover-primary fs-7'>
              {currentUser?.email}
            </span>


          </div>
        </div>

        <PermissionWrapper permission={PERMISSION_CONSTANTS.IMPERSONATION}>
          <div className='separator my-2'></div>
          <Impersonation />
        </PermissionWrapper>
        <div className='separator my-2'></div>
        <Link to={'/profile'} className='menu-link px-5'>
          {t('my_profile')}
        </Link>
      </div>
      <div className='separator my-2'></div>
      <Languages />

      {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Account Settings
        </Link>
      </div> */}

      <div className='menu-item px-5'>
        <a onClick={async () => {
          await logout()
        }} className='menu-link px-5'>
          {t("signout")}
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
